module.exports = __webpack_public_path__ + "img/certificate6.565e6912.png";